module.exports = __webpack_public_path__ + "img/icon-facebook-graph.e8db6f11.svg";